import {
    CropSquare,
    BrowserNotSupported,
    ExitToApp,
    DoorBack,
    EditNote,
    Straighten,
    ChangeHistory,
    FormatAlignJustify,
    DoorSlidingOutlined,
    CircleOutlined,
    Polyline,
    DevicesFold,
    Grid4x4,
    Square,
} from "@mui/icons-material";

import { LeftTabData } from "./interfaces/leftTabData";
import { RightTabData } from "./interfaces/rightTabData";
import { GlassTab } from "../components/rightTabComponents/GlassTab";
import { ProfileTab } from "../components/rightTabComponents/ProfileTab";
import { SelectedTab } from "../components/rightTabComponents/SelectedTab";

export const linhas = [
    { label: "Linha 1", value: "0" },
    { label: "Linha 2", value: "1" },
    { label: "Linha 3", value: "2" },
    { label: "Linha 4", value: "3" },
];

export const referencias = [
    { label: "Referencia 1", value: "0" },
    { label: "Referencia 2", value: "1" },
    { label: "Referencia 3", value: "2" },
    { label: "Referencia 4", value: "3" },
];

export const MAX_PROFILE_WIDTH = 300;

export const boxFlexCenterStyle = {
    display: "flex",
    margin: "10px 0px",
    alignItems: "center",
    justifyContent: "space-between",
    width: "265px"
};

export const leftTabs: LeftTabData[] = [
    {
        label: "Esquadrias",
        accordions: [
            {
                name: "Contornos",
                content: [ 
                    { component: CropSquare, tip: "Janela", toolAction: "frame_scalable" },
                    { component: DoorBack, tip: "Porta", toolAction: "door" },
                    { component: Polyline, tip: "Frame Mão Livre", toolAction: "frame_polygon" },
                    { component: BrowserNotSupported, tip: "Montante/Travessa", toolAction: "mullion_cross_line" },
                ],
            },
            {
                name: "Modelos",
                content: [
                    { component: ChangeHistory, tip: "Abrir", toolAction: "sash" },
                    { component: DevicesFold, tip: "Camarão", toolAction: "foldSash" },
                    { component: DoorSlidingOutlined, tip: "Abrir dupla", toolAction: "doubleSash" },
                    { component: ExitToApp, tip: "Correr", toolAction: "slide" },
                    { component: FormatAlignJustify, tip: "Preenchimento Veneziana", toolAction: "fillerShade" },
                    { component: Square, tip: "Preenchimento Painel", toolAction: "fillerPanel" },
                    { component: Grid4x4, tip: "Preenchimento Tela", toolAction: "fillerScreen" },
                ]
            },
            {
                name: "Cotas e Anotações",
                content: [
                    { component: Straighten, tip: "Cota Extra", toolAction: "extraDimArbitrary" },
                    { component: EditNote, tip: "Anotação", toolAction: "note" },
                ],
            },
        ]
    },

    {
        label: "Vidro Temperado",
        accordions: [
            {
                name: "Vidros",
                content: [
                    { component: CropSquare, tip: "Frame", toolAction: "frame_scalable" },
                    { component: Polyline, tip: "Frame Mão Livre", toolAction: "frame_polygon" },
                ]    
            },
            {
                name: "Modelos",
                content: [
                    { component: ChangeHistory, tip: "Abrir", toolAction: "sash" },
                    { component: DoorSlidingOutlined, tip: "Abrir dupla", toolAction: "doubleSash" },
                    { component: ExitToApp, tip: "Correr", toolAction: "slide" },
                ]
            },
            {
                name: "Componentes",
                content: [
                    { component: CircleOutlined, tip: "Furo no Vidro", toolAction: "glassHole" },
                ],
            },
            {
                name: "Cotas e Anotações",
                content: [
                    { component: Straighten, tip: "Cota Extra", toolAction: "extraDimArbitrary" },
                    { component: EditNote, tip: "Anotação", toolAction: "note" },
                ],
            },
        ]
    }
];

export const rightTabs: RightTabData[] = [
    {
        label: "Perfis",
        content: ProfileTab,
    },
    {
        label: "Vidros",
        content: GlassTab,
    },
    {
        label: "Selecionado",
        content: SelectedTab,
    }
];